import Icon from '@repo/ui/icon';

import {
  handleFormatDate,
  handleGetFromDateFromPlayDates,
  handleGetToDateFromPlayDates,
  toClassName,
} from 'helpers/format';

import { styles } from '.';

type TProps = {
  playDates:
    | {
        date?: string | undefined;
        location?: string | undefined;
        url?: string | undefined;
        _key: string;
      }[]
    | undefined;
  t: any;
  className?: string;
  isWithShadow?: boolean;
};

const DateTerm = (props: TProps) => {
  const { playDates, t, className, isWithShadow = true } = props;

  const fromDate = handleFormatDate(
    handleGetFromDateFromPlayDates(playDates) ?? '',
    t,
  );
  const toDate = handleFormatDate(
    handleGetToDateFromPlayDates(playDates) ?? '',
    t,
  );

  if (playDates === undefined || playDates?.length === 0) {
    return;
  }

  return (
    <div className={toClassName(styles.container, className)}>
      <p
        className={toClassName(
          styles.paragraph,
          isWithShadow && 'text-shadow-lg',
        )}
      >
        {fromDate}
      </p>
      <Icon accessor="arrow-right" />
      <p
        className={toClassName(
          styles.paragraph,
          isWithShadow && 'text-shadow-lg',
        )}
      >
        {toDate}
      </p>
    </div>
  );
};

export default DateTerm;
